export class TeamPlayerCounts {

  private static keys = ['eligiblePlayersCount', 'approvedPlayersCount', 'inReviewPlayersCount', 'deniedPlayersCount', 'missingInfoPlayersCount', 'allPlayersCount'];

  allPlayersCount: number;
  missingInfoPlayersCount: number;
  eligiblePlayersCount: number;
  approvedPlayersCount: number;
  inReviewPlayersCount: number;
  deniedPlayersCount: number;

  constructor(data) {
    TeamPlayerCounts.keys.forEach(k => this[k] = +data[k]);
  }

}

export class TeamPlayer {

  private static numKeys = ['teamUserID', 'teamID', 'userID', 'positionID', 'statusID', 'orgDualRoster', 'dualRosterApprovedBy', 'currentAge'
    , 'isAssoPassed', 'isBirthCertPassed', 'isPhotoPassed', 'isAddressPassed', 'isMiddleNamePassed', 'isPlayeHasValidAge', 'isSorApproved', 'isSafeSportApproved', 'cost', 'needRelease', 'stateID'];
  private static stringKeys = ['gender', 'firstName', 'lastName', 'middleName', 'email', 'jerseyNumber', 'profilePhoto', 'playerName', 'type'
    , 'status', 'color', 'missingInfoAndDocument', 'position', 'dateRegisteredText', 'statusUpdatedDateText', 'address1', 'city', 'zip', 'registeredFees'];
  private static dateKeys = ['dob', 'dualRosterApprovedDate', 'dateRegistered', 'statusUpdated'];

  teamUserID: number;
  teamID: number;
  userID: number;
  positionID: number;
  statusID: number;
  orgDualRoster: number;
  dualRosterApprovedBy: number;
  currentAge: number;
  isAssoPassed: number;
  isBirthCertPassed: number;
  isPhotoPassed: number;
  isAddressPassed: number;
  isMiddleNamePassed: number;
  isPlayeHasValidAge: number;
  isSorApproved: number;
  isSafeSportApproved: number;
  cost: number;


  teamName: string;
  gender: string;
  firstName: string;
  lastName: string;
  middleName: string;
  email: string;
  jerseyNumber: string;
  profilePhoto: string;
  playerName: string;
  type: string;
  status: string;
  color: string;
  missingInfoAndDocument: string;
  position: string;
  registeredFees: string;

  deleted: boolean;

  dob: Date;
  dualRosterApprovedDate: Date;
  dateRegistered: Date;
  statusUpdated: Date;

  checked?: boolean;

  constructor(data) {
    TeamPlayer.numKeys.forEach(n => this[n] = +data[n] || 0);
    TeamPlayer.stringKeys.forEach(s => this[s] = data[s]);
    TeamPlayer.dateKeys.forEach(d => this[d] = (data[d] ? new Date(data[d]) : null));
    this.deleted = !!data.deleted;
    this.gender = (data.gender || '').toLowerCase();
    this.teamName = data.name;
  }
}

export class ClubTeamPlayers {

  private static StringKeys = ['type', 'firstName', 'middleName', 'lastName', 'fullName', 'gender', 'email', 'profilePhoto', 'paymentStatus'];
  private static NumKeys = ['teamRosterID', 'userID', 'active', 'age', 'isECNLTeam'];
  private static dateKeys = ['dob'];

  teamRosterID: number;
  userID: number;
  active: number;
  age: number;
  dob: Date;
  isECNLTeam: number;
  type: string;
  firstName: string;
  middleName: string;
  lastName: string;
  fullName: string;
  gender: string;
  email: string;
  profilePhoto: string;
  paymentStatus: string;

  constructor(data) {
    ClubTeamPlayers.NumKeys.forEach(n => this[n] = +data[n] || 0);
    ClubTeamPlayers.StringKeys.forEach(s => this[s] = data[s] || '');
    ClubTeamPlayers.dateKeys.forEach(d => this[d] = (data[d] ? new Date(data[d]) : null));
    this.type = this.type.toLowerCase();
  }
}

export class ClubTeamPlayersList {

  clubTeamPlayerList: ClubTeamPlayers[];
  totalAllPlayers: number;
  totalFirstTeamPlayers: number;
  totalGuestPlayers: number;

  constructor(data) {
    this.clubTeamPlayerList = (data || []).map(t => new ClubTeamPlayers(t));
    this.totalFirstTeamPlayers = this.clubTeamPlayerList.filter(t => t.type == 'first team player').length;
    this.totalGuestPlayers = this.clubTeamPlayerList.filter(t => t.type == 'guest player').length;
    this.totalAllPlayers = this.clubTeamPlayerList.length;
  }
}



// WEBPACK FOOTER //
// ./src/app/models/association/team-players.ts